import { useSelector } from 'react-redux';
import { profileSelector } from 'reducers/profile';
import { PermissionName, RoleName } from 'types/Role';

const usePermission = () => {
  const { role, allowDs, enterprise } = useSelector(profileSelector);

  const requirePermission = (permission: PermissionName) => {
    return role?.permissions && role?.permissions.includes(permission);
  };

  const requireRole = (roleName: RoleName, containMaster: boolean = true) => {
    return role?.name === roleName || (containMaster && (role?.name === 'MASTER' || role?.name === 'SUB_MASTER'));
  };

  const requireUserPC = () => {
    return ['MASTER', 'SUB_MASTER', 'SUPPORTER', 'CA_SENIOR', 'CREDIT_OFFICER']
      .concat(['CRM_SENIOR', 'CRM', 'ACCOUNTANT', 'ACC_CONTROLLER'])
      .includes(role?.name!);
  };

  const requireUserPCManager = () => {
    return ['MASTER', 'SUB_MASTER'].includes(role?.name!);
  };

  const isAccountantRoles = () => {
    return ['ACCOUNTANT', 'ACC_CONTROLLER'].includes(role?.name!);
  };

  const signable = () => {
    return allowDs || role?.name === 'MASTER';
  };

  const getEnterpriseId = () => {
    return enterprise?.id!;
  };

  return {
    requirePermission,
    requireRole,
    requireUserPC,
    requireUserPCManager,
    isAccountantRoles,
    signable,
    getEnterpriseId,
  };
};

export default usePermission;
